import App from 'app/app.js';

function OrdersService($http, $q) {
  this.getOrders = function () {
    var dfd = $q.defer(),
      url = 'orders/';

    $http
      .get(url)
      .then(function (response) {
        if (!response.data.success) {
          dfd.reject(response.data.error);
        } else {
          dfd.resolve(response.data.data);
        }
      })
      .catch(function () {
        dfd.reject('ORDERS_FAIL_GENERIC_MESSAGE');
      });
    return dfd.promise;
  };

  this.getOrderSummary = function (orderId) {
    var dfd = $q.defer(),
      url = 'orderSummary/' + orderId;
    $http
      .get(url)
      .then(function (response) {
        if (!response.data.success) {
          dfd.reject(response.data.error);
        } else {
          dfd.resolve(response.data.data);
        }
      })
      .catch(function (errResponse) {
        if (errResponse.status === 419) {
          return dfd.reject('SESSION_TIMEOUT');
        }
        dfd.reject('ORDERS_FAIL_GENERIC_MESSAGE');
      });
    return dfd.promise;
  };

  this.getOrderStatus = function (orderId) {
    var dfd = $q.defer(),
      url = 'orderStatus/' + orderId;
    $http
      .get(url)
      .then(function (response) {
        if (!response.data.success) {
          dfd.reject(response.data.error);
        } else {
          dfd.resolve(response.data.data);
        }
      })
      .catch(function () {
        dfd.reject('ORDERS_FAIL_GENERIC_MESSAGE');
      });
    return dfd.promise;
  };

  this.getDateForToday = function () {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    today = mm + '/' + dd + '/' + yyyy;
    return new Date(today);
  };

  this.getOrderPaymentNumber = function (order) {
    var displayOrderId = null;
    if (!!order) {
      if (order.paymentVoucherId !== null) {
        displayOrderId = order.paymentVoucherId;
      } else {
        displayOrderId = order.payment.paymentAttempt.paymentServiceTranId;
      }
    }
    return displayOrderId;
  };
}

App.service('OrdersService', ['$http', '$q', OrdersService]);
